/**
 * Single source of truth for the API base URL.
 *
 * Vite inlines `VITE_API_URL` into the static bundle at BUILD time. The deploy
 * workflow sets it to the App Runner service URL; `pnpm dev` falls back to the
 * local API. The real /api/v1 client (see IPlanDataClient in planDataClient.ts)
 * reads this — no component ever hardcodes a host. Trailing slashes are trimmed
 * so callers can safely join `${API_BASE_URL}/api/v1/...`.
 */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_URL?.replace(/\/+$/, '') ?? 'http://localhost:3000';

/**
 * True when a real API URL was configured at build time. This is the switch
 * between "talk to the real RLS-backed API" (auth + fact-find over HTTP) and the
 * fixture/offline-demo mode: only set `VITE_API_URL` for an environment that has
 * a reachable `/api/v1` service. Deliberately checks the RAW env var (not the
 * localhost fallback) so an unconfigured build never silently points at a host.
 */
export const API_CONFIGURED: boolean =
  typeof import.meta.env.VITE_API_URL === 'string' && import.meta.env.VITE_API_URL.trim() !== '';
